(function ($, Drupal) {
  Drupal.behaviors.scrollToViewResults = {
    attach: function (context, settings) {
      $(document).ajaxSuccess(function (event, xhr, settings) {
        // Проверяваме дали това е заявка към твоя view (по пътя или по form елемент)
        if (settings.url.includes('/views/ajax')) {
          // Изчакай малко за да се заредят резултатите
          // setTimeout(function () {
            const $target = $('.view-tires.view-display-id-tires_page .view-main-content'); // или друг контейнер
            if ($target.length) {
              $('html, body').animate({
                scrollTop: $target.offset().top - 100 // корекция ако имаш фикс меню
              }, 1);
            }
          // }, 100);
        }
      });
    }
  };
})(jQuery, Drupal);
